// extracted by mini-css-extract-plugin
export var blue = "_3e-g";
export var brand = "_3e-c";
export var darkGrey = "_3e-f";
export var disabled = "_3e-6";
export var disabledSubtle = "_3e-7";
export var error = "_3e-8";
export var green = "_3e-h";
export var grey = "_3e-e";
export var icon = "_3e-0";
export var inherit = "_3e-b";
export var lightGrey = "_3e-d";
export var orange = "_3e-j";
export var pink = "_3e-l";
export var primary = "_3e-1";
export var purple = "_3e-m";
export var quaternary = "_3e-4";
export var quinary = "_3e-5";
export var red = "_3e-k";
export var secondary = "_3e-2";
export var success = "_3e-a";
export var tertiary = "_3e-3";
export var warning = "_3e-9";
export var white = "_3e-n";
export var yellow = "_3e-i";